import { Container, Table } from 'react-bootstrap'
import Link from 'next/link'
import { Request } from '@group-devs/yfp7-global-modules'
import { useState, useEffect } from 'react'

const request = new Request(process.env.apiDomain)

function convertTime(timestamp) {
    const unixTimestamp = parseInt(timestamp)
    const date = new Date(unixTimestamp * 1000)
    return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    })
}

export default function ActivityContentReview({ props }) {
    const [contactId, setContactId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 15

    const authContactId = props.auth.site_user ? props.auth.contactId : null
    const { data: contactAccount } = request.contacts.swrAccount(authContactId)

    const contentTypes = {
        1: 'Article',
        2: 'Video',
        4: 'Files',
        11: 'Video',
        12: 'Recipe'
    }

    useEffect(() => {
        if (typeof contactAccount !== 'undefined') {
            setContactId(parseInt(contactAccount.contact_id))
        }
    }, [contactAccount])

    const { data: contentData } = request.stats.contentViewed(contactId)

    let allContents = []
    if (contentData) {
        try {
            allContents = JSON.parse(contentData.content)
        } catch (err) {
            console.error("Invalid contentData format", err)
        }
    }

    const totalPages = Math.ceil(allContents.length / itemsPerPage)
    const paginatedContents = allContents.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    )

    return (
        <Container className="py-5">
            <h4 className="font-weight-bold py-2 mb-lg-5 mb-2">My Content Reviewed</h4>
            <Table striped responsive="sm" className="table-hover activity-table">
                <thead>
                    <tr>
                        <th>Content</th>
                        <th>Type</th>
                        <th>Date Viewed</th>
                        <th>Points</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedContents.length > 0 ? (
                        paginatedContents.map((item, index) => (
                            <tr key={index}>
                                <td data-label="Content">
                                    <a target="_blank" rel="noopener noreferrer" href={`/a/${item.content.slug}`} className="d-flex align-items-center">
                                        <img
                                            src={
                                                item.content.thumbnail
                                                    ? `${process.env.imageHostingDomain}/${item.content.thumbnail}`
                                                    : item.content.feature_img
                                                        ? `${process.env.imageHostingDomain}/${item.content.feature_img}`
                                                        : '/images/general/yfp-no-image.jpg'
                                            }
                                            alt={item.content.title}
                                        />{" "}
                                        {item.content.title}
                                    </a>
                                </td>
                                <td data-label="Type">{contentTypes[item.content.type] || 'Unknown'}</td>
                                <td data-label="Date Viewed">{convertTime(item.created_at)}</td>
                                <td data-label="Points">{item.earned_point}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td data-label="Status" colSpan="4" className="text-center">
                                No content reviewed yet.
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <nav>
                        <ul className="pagination flex-wrap">
                            {[...Array(totalPages)].map((_, index) => (
                                <li
                                    key={index}
                                    className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                                    onClick={() => setCurrentPage(index + 1)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="page-link">{index + 1}</span>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            )}

            <style jsx global>{`
                .activity-table.table-hover > tbody > tr:hover {
                    background-color: rgb(67 166 73 / 21%);
                }
                .activity-table th {
                    background-color: #43a649;
                    color: #fff;
                    border: 0;
                }
                .activity-table td, .activity-table th {
                    border: 0 !important;
                    vertical-align: middle;
                    padding: .85rem .75rem;
                }
                .activity-table-striped tbody tr:nth-of-type(odd) {
                    background-color: transparent;
                }
                .activity-table-striped tbody tr:nth-of-type(even) {
                    background-color: rgba(0, 0, 0, .05);
                }
                .activity-table td img {
                    max-width: 90px;
                    margin-right: 1rem;
                    border-radius: 4px;
                }
                .pagination .page-item.active .page-link {
                    background-color: #43a649;
                    border-color: #43a649;
                }
                .pagination .page-link {
                    color: #43a649;
                }

                /* Mobile Card Layout - CSS Only */
                @media screen and (max-width: 767px) {
                    .activity-table {
                        border: 0;
                        margin-bottom: 1.5rem;
                    }
                    .activity-table thead {
                        display: none;
                    }
                    .activity-table tr {
                        display: block;
                        margin-bottom: 1.5rem;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        padding: 1rem;
                        background: #fff;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .activity-table td {
                        display: block;
                        text-align: right;
                        padding: 1px 0;
                        position: relative;
                        border: none;
                        background: none;
                    }
                    .activity-table td::before {
                        content: attr(data-label) ": ";
                        position: absolute;
                        left: 0;
                        width: 45%;
                        padding-right: 10px;
                        white-space: nowrap;
                        font-weight: 600;
                        color: #43a649;
                        text-align: left;
                    }
                    .activity-table td[data-label="Content"] {
                        text-align: left;
                        padding-bottom: 1rem;
                        border-bottom: 1px solid #eee;
                    }
                    .activity-table td[data-label="Content"]::before {
                        display: block;
                        position: static;
                        width: 100%;
                        font-size: 1.1em;
                        margin-bottom: .5rem;
                        font-weight: bold;
                    }
                    .activity-table td[data-label="Content"] a {
                        display: flex;
                        align-items: center;
                        text-decoration: none;
                    }
                    .activity-table td[data-label="Content"] img {
                        max-width: 60px !important;
                        margin-right: .75rem;
                        flex-shrink: 0;
                    }
                    .activity-table td:last-child {
                        border-bottom: 0;
                    }
                }
            `}</style>
        </Container>
    )
}
